import React from "react";
import c from "classnames";

import css from "./block.module.scss";

const ContentBlock = ({ style, children, iconSrc, className }) => {
  return (
    <div className={c("w-100 h-100 py-5", css["cb-wrapper"], className)} style={style}>
      {children}
    </div>
  );
};

export default ContentBlock;
